import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";

import { useDispatch, useSelector } from "react-redux";
import get, { post } from "../../../lib/requests";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import {
	LoadingMgs,
	SuccessMessage,
	ErrorMessage,
} from "components/Common/toastify";
import { setUser } from "redux/ducks/userSlice";
import { setDashboard } from "redux/ducks/CSPDashboardSlice";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";
const useStyles3 = makeStyles(javascriptStyles);
const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

const InformationData = ({
	selectedDialogData,
	setRequestAccessShow,
	setRequestService,
}) => {
	const classesCSStyles = useStylesCustomerDetailsStyles();
	const [loading, setLoading] = React.useState(false);
	const classes3 = useStyles3();
	const dispatch = useDispatch();
	const userDetails = useSelector((state) => state.user);

	useEffect(() => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
		return function cleanup() {};
	});

	const requestAccess = () => {
		if (userDetails["services-assigned"]) {
			const assignService = userDetails["services-assigned"].find(
				(service) => service === selectedDialogData.Heading
			);

			if (selectedDialogData.orderManual === "manual_form" && assignService) {
				dispatch(
					setDashboard({
						TeamT5Form: true,
					})
				);
			} else if (
				selectedDialogData.orderManual === "manual_form_kinetix" &&
				assignService
			) {
				dispatch(
					setDashboard({
						KinetixForm: true,
					})
				);
			} else if (selectedDialogData.orderManual !== "" && assignService) {
				window.open(selectedDialogData.orderManual, "_blank");
			} else {
				accessRequest();
			}
		} else {
			setRequestAccessShow(true);
			setRequestService(selectedDialogData.Heading);
			accessRequest();
		}
	};

	const accessRequest = async () => {
		setLoading(true);
		LoadingMgs("Request Access", "processing...");
		const formField = {
			service: selectedDialogData.Heading,
		};
		try {
			await post("/api/accessrequest", formField, true)
				.then((res) => {
					if (res.data.success) {
						SuccessMessage("Request Access", res.data.message);
						if (res.data.records.haveaccess) {
							console.log(res.data.records.haveaccess, "res.data.haveaccess");
							verifyLogin();
						}
					} else {
						ErrorMessage("Request Access", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Request Access", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Request Access", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	const verifyLogin = async () => {
		try {
			await get("/api/verifylogin", true)
				.then((res) => {
					if (res.data.success) {
						dispatch(setUser(res.data.records));
					} else {
						ErrorMessage("Request Access", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Request Access", message);
					setLoading(false);
				});
		} catch (error) {
			console.log("error", error);
			ErrorMessage("Request Access", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	const checkIfHaveAccess = (service) => {
		if (userDetails["services-assigned"]) {
			const assignService = userDetails["services-assigned"].find(
				(service) => service === selectedDialogData.Heading
			);

			if (selectedDialogData.orderManual === "manual_form" && assignService) {
				return "Place a Manual Order " + selectedDialogData.Heading;
			} else if (
				selectedDialogData.orderManual === "manual_form_kinetix" &&
				assignService
			) {
				return "Place a Manual Order " + selectedDialogData.Heading;
			} else if (selectedDialogData.orderManual !== "" && assignService) {
				return "Login to " + selectedDialogData.Heading;
			} else {
				return selectedDialogData.requestAcess;
			}
		} else {
			return selectedDialogData.requestAcess;
		}
	};

	return (
		<Card className={classesCSStyles?.mx5}>
			<CardBody>
				<div className={classes3.containerBox}>
					<br />
					<h4>
						<img
							src={selectedDialogData?.imageUrl}
							alt={selectedDialogData?.Heading}
							className={classes3.modelTitleImg}
						/>
					</h4>
					<div
						id="classic-modal-slide-description"
						className={classNames(classes3.py5)}>
						<hr className={classNames(classes3.py5)} />
						<div className={classes3.paragraphBold}>{selectedDialogData?.Body}</div>
						<hr className={classNames(classes3.py5)} />
						<div className={classes3.paragraphTitle}>
							<span>
								<i className="fas fa-star" />
							</span>
							Key Features:
						</div>
						<div className={classes3.paragraph}>
							<ul>
								{selectedDialogData?.KeyFeatures.map((feature, index) => (
									<li key={index}>
										<span>
											<i className="fas fa-angle-double-right" />
										</span>
										{feature}
									</li>
								))}
							</ul>
						</div>
					</div>
					<div className={classes3.modalFooter}>
						{selectedDialogData?.download != "" && (
							<a
								href={selectedDialogData?.download}
								target="_blank"
								rel="noopener noreferrer">
								<button className={classesCSStyles?.buttonPrimary}>
									Download the Current Pricebook
								</button>
							</a>
						)}

						<button
							className={classesCSStyles?.buttonPrimary}
							onClick={() => {
								requestAccess();
							}}>
							{checkIfHaveAccess(selectedDialogData.Heading)}
						</button>
					</div>
				</div>
			</CardBody>
		</Card>
	);
};

export default InformationData;
